export interface IKanbanColumn {
  // identifies the column in the UI
  key: string;
  label: string;
  // value of the `column` query param (budget status for the user role, comma-separated)
  column: string;
}

export const getKanbanColumns = (persona?: string): IKanbanColumn[] =>
  persona === "MANAGER"
    ? [
      { key: "SENT", label: "Enviados para análise", column: "SENT" },
      { key: "APPROVED", label: "Aprovado pelo gestor", column: "APPROVED" },
      { key: "REJECTED", label: "Recusado pelo gestor", column: "REJECTED" },
    ]
    : [
      { key: "IN_REVIEW", label: "Pendente de ação", column: "IN_REVIEW" },
      { key: "SENT", label: "Enviado", column: "SENT" },
      { key: "APPROVED", label: "Concluído", column: "APPROVED,REJECTED" },
    ];
